import React from 'react';

import type {Ref} from '../../../state/views/filter/types';
import type {DefaultToggleFilter} from '../../../util/filterTypes';
import {type Config as TableSettings} from '../../../util/runfeed';
import {WBTableActionFilter} from '../WBTable/WBTableActionsFilter';
import {RunsFilterButton} from './RunsFilterButton';
import {RunsFilterKeySelector} from './RunsFilterKeySelector';
import {RunsFilterPicker} from './RunsFilterPicker';
import {RunsFilterValueSelector} from './RunsFilterValueSelector';

interface RunsFilterTableActionProps {
  entityName: string;
  projectName: string;
  tableSettings: TableSettings;
  compact?: boolean;
  filtersRef: Ref;
  notificationOpen: boolean;
  pickerOpen: boolean;

  defaultToggleFilters?: DefaultToggleFilter[];
  setPickerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onFiltersChanged(): void;
}

export const RunsFilterTableAction = ({
  compact,
  defaultToggleFilters,
  entityName,
  filtersRef,
  notificationOpen,
  onFiltersChanged,
  pickerOpen,
  projectName,
  setPickerOpen,
  tableSettings,
}: RunsFilterTableActionProps) => {
  return (
    <WBTableActionFilter
      open={pickerOpen}
      setOpen={setPickerOpen}
      trigger={filtersOpen => (
        <RunsFilterButton
          notificationOpen={notificationOpen}
          compact={compact}
          filtersOpen={filtersOpen}
          filtersRef={filtersRef}
        />
      )}
      content={
        <RunsFilterPicker
          entityName={entityName}
          projectName={projectName}
          filtersRef={filtersRef}
          defaultToggleFilters={defaultToggleFilters}
          onFiltersChanged={onFiltersChanged}
          filterKeySelector={filterKeySelectorProps => (
            <RunsFilterKeySelector
              {...filterKeySelectorProps}
              entityName={entityName}
              projectName={projectName}
              tableSettings={tableSettings}
            />
          )}
          filterValueSelector={filterValueSelectorProps => {
            return (
              <RunsFilterValueSelector
                {...filterValueSelectorProps}
                entityName={entityName}
                projectName={projectName}
              />
            );
          }}
        />
      }
    />
  );
};
